import { ReactNode } from 'react';
import { usePermissions } from '@/hooks/usePermissions';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface PermissionGateProps {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
  showTooltip?: boolean;
}

export const PermissionGate = ({ 
  permission, 
  children, 
  fallback = null,
  showTooltip = true 
}: PermissionGateProps) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return <>{fallback}</>;
  }

  if (!hasPermission(permission)) {
    if (showTooltip && typeof children === 'object' && children !== null) {
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="opacity-50 cursor-not-allowed">
                {children}
              </div>
            </TooltipTrigger>
            <TooltipContent>
              <p>You don't have permission: {permission}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
